module.exports = __webpack_public_path__ + "img/whatsapp_gray.916fed7e.svg";